import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import * as Http from "../../../http";
import Loading from "../../../components/Loading";
import * as Business from "../../../utils/business";

export default class ReportChild extends Component {
  state = {
    items: [],
    loading: true,
    isShow: false,
  };

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.CAPITAL_PLANING,
      this.props.report.file_name,
    ).then((data) => {
      const lstReports = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          lstReports.push(item);
        });
      }
      this.setState({
        items: lstReports,
        loading: false,
      });
    });
  };

  onSaveAllFiles = async () => {
    if (this.state.items && this.state.items.length > 0) {
      const fileArr = [];
      for (let i = 0; i < this.state.items.length; i++) {
        const fileInfo = Http.makeDownloadFileInfo(
          this.state.items[i].report_name,
          this.props.report.report_date,
          this.props.report.file_name,
          null,
          Business.COMPONENT.CAPITAL_PLANING,
        );
        fileArr.push(fileInfo);
      }
      Http.downloadAllFiles(
        fileArr,
        this.props.report.report_date,
        this.props.report.file_name,
      );
    }
  };

  show = () => {
    this.setState({
      isShow: true,
      loading: true,
    });
    this.getReportList();
  };

  close = () => {
    this.setState({
      isShow: false,
    });
  };

  renderContent = (items) => (
    <Modal.Body>
      <div className="content table-responsive table-full-width">
        <table className="table table-hover table-striped">
          <tbody>
            {items.map((item, index) => (
              <tr key={item.report_name}>
                <td>{index}</td>
                <td>
                  <a
                    style={{ color: "blue" }}
                    onClick={() => {
                      Http.downloadFile(
                        item.report_name,
                        this.props.report.report_date,
                        this.props.report.file_name,
                        null,
                        Business.COMPONENT.CAPITAL_PLANING,
                      );
                    }}
                  >
                    {item.report_name}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ float: "right" }}>
          <button
            type="button"
            className="btn btn-primary"
            style={{
              backgroundColor: "#FFE600",
              borderColor: "#7F7E82",
              borderRadius: "5px",
              fontWeight: 600,
            }}
            onClick={this.onSaveAllFiles}
          >
            SAVE ALL FILES
          </button>
        </div>
      </div>
    </Modal.Body>
  );

  renderLoading = () => (
    <div>
      <div style={{ height: 60 }}>
        <Loading size="small" />
      </div>
      <div style={{ height: 30 }} />
    </div>
  );

  render() {
    const { items } = this.state;

    return (
      <div>
        <a
          href="#url"
          style={{ color: "blue" }}
          onClick={(e) => {
            e.preventDefault();
            this.show();
          }}
        >
          {this.props.report.report_name}
        </a>
        <Modal show={this.state.isShow} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.report.report_name}</Modal.Title>
          </Modal.Header>
          {this.state.loading
            ? this.renderLoading()
            : this.renderContent(items)}
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/CapitalPlanning/Report/ReportChild.js